/* Aventurx — EICMA DAYS (snippets/axr-eicma.liquid, sections/axr-eicma-*.liquid).
   Parte solo quando <html> ha la classe axr-ei-on: la mette lo script scritto in <head> nelle date di
   Impostazioni tema → Aventurx — EICMA Days (ora italiana) o in anteprima, e la toglie alla fine.
   Easter egg, ognuno sblocca un premio segreto (codice creato in Shopify → Sconti):
   1-2. livelli 1 e 2: caschi e moto nascosti nelle pagine, chi ne trova abbastanza (es. 3 e poi 6) li sblocca;
   3.   livello 3: la moto della testata, toccandola di fila il contagiri sale e al limitatore, dopo i livelli 1 e 2,
        sblocca il terzo premio;
   4.   SPECIALE, RARO: ogni tanto passa una moto d'oro in fondo allo schermo: chi la prende sblocca il quarto;
   5.   SPECIALE, RARO: tra quelli nascosti, a volte, c'è un casco d'oro: sblocca il quinto.
   Ogni premio ha un prodotto fisso e le sue condizioni (prodotti nel carrello, spesa minima): nel carrello il
   conteggio arriva dal Liquid senza omaggi e prodotti dei premi, e il premio dice cosa manca.
   I fari («Accendi i fari», «vroom») sono stati tolti: nel tema la funzione è sempre spenta (lights: false).
   Premi trovati e conteggio restano nel browser del cliente (localStorage) e compaiono nel carrello e nella
   fascia della caccia. I codici arrivano dal Liquid codificati e si leggono solo quando un premio è sbloccato.
   I disegni arrivano dal <template id="AxrEiArt">. Ogni elemento creato ha la classe axr-ei-only, quindi
   sparisce da solo quando la promo finisce. */
(function () {
  if (window.axrEicma) return;
  window.axrEicma = true;

  var cfg = window.axrEiCfg || {};
  var S = cfg.strings || {};
  // le traduzioni di Shopify arrivano scritte per l'HTML («d&#39;oro», «&quot;»): i messaggi le mettono come testo, quindi si decodificano qui
  (function () {
    var ta = document.createElement('textarea');
    for (var k in S) {
      if (typeof S[k] === 'string' && S[k].indexOf('&') !== -1) { ta.innerHTML = S[k]; S[k] = ta.value; }
    }
  })();
  var root = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var started = false;
  var KEY = 'axrEi26';

  function isOn() { return root.classList.contains('axr-ei-on'); }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function el(tag, cls) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    return e;
  }
  function remove(e) { if (e && e.parentNode) e.parentNode.removeChild(e); }
  function fmt(s, vals) {
    return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return vals && vals[k] != null ? vals[k] : m; });
  }
  function track(name, data) {
    try {
      var ev = { event: name };
      for (var k in data) ev[k] = data[k];
      (window.dataLayer = window.dataLayer || []).push(ev);
    } catch (e) { /* niente statistiche */ }
  }
  // disegno dal template, dentro uno span con la classe scelta
  function art(name, cls) {
    var tpl = document.getElementById('AxrEiArt');
    var src = tpl && tpl.content ? tpl.content.querySelector('[data-art="' + name + '"]') : null;
    var wrap = el('span', cls);
    wrap.setAttribute('aria-hidden', 'true');
    if (src) wrap.appendChild(src.cloneNode(true));
    return wrap;
  }

  /* ---------- Memoria: pezzi trovati e premi vinti ---------- */
  var st = { f: 0, w: {} };
  try {
    var saved = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    if (saved && typeof saved === 'object') { st.f = +saved.f || 0; st.w = saved.w || {}; }
  } catch (e) { /* memoria non disponibile (navigazione privata) */ }
  function save() {
    try { window.localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) { /* niente memoria */ }
  }
  function session(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, String(val));
    } catch (e) { /* niente memoria */ }
    return null;
  }

  /* ---------- Premi ---------- */
  var prizes = (cfg.prizes || []).filter(function (p) { return p && p.k; });
  function prize(id) {
    for (var i = 0; i < prizes.length; i++) if (prizes[i].id === id) return prizes[i];
    return null;
  }
  function won(id) { return !!st.w[id]; }
  // cifre con l'euro davanti, senza i centesimi se tondi (€50, €12,40)
  function money(c) {
    c = Math.max(0, Math.round(+c || 0));
    var r = c % 100;
    return '€' + Math.floor(c / 100) + (r ? ',' + (r < 10 ? '0' : '') + r : '');
  }
  // condizioni del premio, es. «Con almeno 2 prodotti nel carrello (omaggi e premi esclusi)»
  function cond(p) {
    var out = [];
    if (+p.min > 0) out.push(fmt(+p.min === 1 ? S.condItemsOne : S.condItems, { n: p.min }));
    if (+p.spend > 0) out.push(fmt(S.condSpend, { x: money(p.spend) }));
    return out.length ? out.join(' · ') + (S.condNote ? ' (' + S.condNote + ')' : '') : '';
  }
  // cosa manca nel carrello per il premio (vuoto = condizioni raggiunte)
  function missing(p, n, sum) {
    if (+p.min > 0 && n < +p.min) {
      var k = +p.min - n;
      return fmt(k === 1 ? S.missItemsOne : S.missItems, { k: k });
    }
    if (+p.spend > 0 && sum < +p.spend) return fmt(S.missSpend, { x: money(+p.spend - sum) });
    return '';
  }
  // omaggio con un solo modello: si aggiunge da solo al carrello (con le taglie si sceglie nella pagina del prodotto)
  function isGift(p) { return !!(p.product && p.product.variant && p.product.available && p.product.single); }
  function code(p) {
    try { return window.atob(String(p.k).split('').reverse().join('')); } catch (e) { return ''; }
  }
  function findPrizes() {
    return prizes.filter(function (p) { return p.kind === 'find' && p.need > 0; })
      .sort(function (a, b) { return a.need - b.need; });
  }
  // a che punto è la caccia: una frase (t) e cosa manca da fare (d).
  // Livelli 1 e 2 → caschi e moto nascosti; livello 3 → moto della pedana; poi i due speciali rari
  // (moto d'oro di passaggio, casco d'oro tra i caschi nascosti), solo quelli che si possono davvero trovare.
  function huntState() {
    var nx = nextFind();
    if (nx) return { t: fmt(S.nextAt, { left: Math.max(1, nx.need - st.f) }), d: S.nextHint || '' };
    var r = prizes.filter(function (x) { return x.kind === 'rev'; })[0];
    if (r && !won(r.id)) return { t: fmt(S.progressRev, { n: st.f }), d: S.revHintNext || '' };
    var bike = prizes.filter(function (x) { return x.kind === 'bike' && cfg.bike && !won(x.id); })[0];
    var gold = prizes.filter(function (x) { return x.kind === 'gold' && +cfg.gold > 0 && !won(x.id); })[0];
    if (bike || gold) {
      return {
        t: fmt(S.progressLevels, { n: st.f }),
        d: (bike && gold ? S.specialBoth : (bike ? S.specialBike : S.specialGold)) || ''
      };
    }
    return { t: fmt(S.progressDone, { n: st.f }), d: S.doneHint || '' };
  }
  function doneMsg() {
    var h = huntState();
    return h.d ? h.t + ' ' + h.d : h.t;
  }
  function nextFind() {
    var list = findPrizes();
    for (var i = 0; i < list.length; i++) if (!won(list[i].id)) return list[i];
    return null;
  }
  function win(id, from) {
    var p = prize(id);
    if (!p) return false;
    if (won(id)) return false;
    st.w[id] = Date.now();
    save();
    track('axr_eicma_prize', { prize_id: id, prize_kind: p.kind, from: from || p.kind });
    openModal(p);
    paintHunt();
    paintCarts();
    return true;
  }

  /* ---------- Caschi e moto nascosti ---------- */
  var hidden = false;
  function hideItems() {
    if (hidden || !isOn()) return;
    hidden = true;
    var n = Math.max(0, Math.min(6, parseInt(cfg.hidden, 10) || 0));
    if (!n) return;
    var list = Array.prototype.slice.call(document.querySelectorAll('#content .shopify-section, .product-block, .axr-footer, .footer'))
      .filter(function (h) {
        if (h.offsetParent === null) return false;
        if (h.closest('.axr-ei-modal, .cc-popup, [aria-hidden="true"]')) return false;
        if (h.querySelector('.axr-ei-hidden')) return false;
        var r = h.getBoundingClientRect();
        return r.width >= 120 && r.height >= 100;
      });
    if (!list.length) return;
    var tops = list.map(function (h) { return h.getBoundingClientRect().top + window.pageYOffset; });
    var order = list.map(function (h, i) { return i; }).sort(function () { return Math.random() - 0.5; });
    // sparsi lungo la pagina: prima quelli lontani fra loro, poi gli altri se non bastano
    var chosen = [];
    order.forEach(function (i) {
      if (chosen.length < n && chosen.every(function (c) { return Math.abs(tops[c] - tops[i]) > 300; })) chosen.push(i);
    });
    order.forEach(function (i) {
      if (chosen.length < n && chosen.indexOf(i) === -1) chosen.push(i);
    });
    // casco d'oro: raro, solo per chi ha già trovato qualcosa e non l'ha ancora vinto
    var gold = -1;
    var goldPrize = prizes.filter(function (p) { return p.kind === 'gold'; })[0];
    if (goldPrize && !won(goldPrize.id) && st.f >= 2 && Math.random() * 100 < (+cfg.gold || 0)) {
      gold = Math.floor(Math.random() * chosen.length);
    }
    chosen.forEach(function (i, k) { place(list[i], k, k === gold); });
  }
  function place(host, k, isGold) {
    var card = host.matches('.product-block');
    // schede: dentro il riquadro della foto, non sotto (lì ci sono nome e prezzo)
    var box = card ? (host.querySelector('.image-cont') || host) : host;
    if (window.getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var kind = isGold ? 'helmet-gold' : (Math.random() < 0.6 ? 'helmet' : 'bike');
    var b = el('button', 'axr-ei-hidden axr-ei-only axr-ei-hidden--' + kind);
    b.type = 'button';
    b.setAttribute('aria-label', (kind === 'bike' ? S.bikeLabel : (isGold ? S.goldLabel : S.helmetLabel)) || '');
    b.setAttribute('data-ei-kind', kind);
    // i caschi nascosti in due colori: bianco e rosso, o nel giallo Aventurx
    b.appendChild(art(kind === 'helmet' && Math.random() < 0.5 ? 'helmet-y' : kind));
    var size = Math.round(kind === 'bike' ? rand(38, 48) : rand(26, 34));
    b.style.width = size + 'px';
    b.style.height = Math.round(kind === 'bike' ? size * 0.58 : size) + 'px';
    if (card) {
      // in basso a destra sulla foto, sopra il pulsante di acquisto rapido (in alto ci sono etichette e pass)
      b.style.bottom = Math.round(rand(46, 64)) + 'px';
      b.style.right = Math.round(rand(6, 14)) + 'px';
    } else {
      // sezioni: sul bordo, nel margine della pagina; almeno 6 px dal bordo, così non esce dallo schermo
      b.style.top = Math.round(rand(12, 78)) + '%';
      b.style[Math.random() < 0.5 ? 'left' : 'right'] = Math.round(rand(6, 10)) + 'px';
    }
    b.style.setProperty('--hd-rot', Math.round(rand(-18, 18)) + 'deg');
    b.style.setProperty('--hd-delay', rand(0, 5).toFixed(1) + 's');
    b.setAttribute('data-ei-k', String(k));
    box.appendChild(b);
  }
  function burst(from, gold) {
    if (reduce) return;
    var r = from.getBoundingClientRect();
    for (var i = 0; i < 7; i++) {
      var b = el('span', 'axr-ei-burst axr-ei-only' + (gold ? ' axr-ei-burst--gold' : ''));
      b.style.left = (r.left + r.width / 2) + 'px';
      b.style.top = (r.top + r.height / 2) + 'px';
      b.style.setProperty('--bx', Math.round(rand(-110, 110)) + 'px');
      b.style.setProperty('--by', Math.round(rand(-130, -30)) + 'px');
      b.style.setProperty('--br', Math.round(rand(-60, 60)) + 'deg');
      document.body.appendChild(b);
      setTimeout(remove.bind(null, b), 900);
    }
  }
  function foundItem(b) {
    if (b.classList.contains('is-found')) return;
    b.classList.add('is-found');
    var kind = b.getAttribute('data-ei-kind');
    burst(b, kind === 'helmet-gold');
    setTimeout(remove.bind(null, b), 600);
    if (kind === 'helmet-gold') {
      var gp = prizes.filter(function (p) { return p.kind === 'gold'; })[0];
      track('axr_eicma_gold', {});
      if (gp && win(gp.id, 'gold')) return;
    }
    st.f += 1;
    save();
    track('axr_eicma_found', { found: st.f });
    // premio della caccia raggiunto?
    var list = findPrizes();
    for (var i = 0; i < list.length; i++) {
      if (!won(list[i].id) && st.f >= list[i].need) { win(list[i].id, 'find'); return; }
    }
    paintHunt();
    var nx = nextFind();
    if (nx) toast(fmt(S.progress, { n: st.f, left: Math.max(1, nx.need - st.f) }), 'helmet');
    else toast(doneMsg(), 'helmet');
  }

  /* ---------- La moto che rinvia: contagiri fino al limitatore ---------- */
  var rpm = 0;
  var decayT = 0;
  var decayI = 0;
  function gauge(stage) {
    var t = stage && stage.querySelector('[data-ei-tacho]');
    if (!t) return;
    var max = Math.max(3, parseInt(cfg.rev, 10) || 8);
    var f = Math.min(1, rpm / max);
    t.style.setProperty('--rpm', f.toFixed(3));
    var fill = t.querySelector('.axr-ei-tacho__fill');
    if (fill) fill.style.strokeDashoffset = String(Math.round(100 - f * 100));
    t.classList.toggle('is-hot', f >= 0.75);
    stage.classList.toggle('is-revving', rpm > 0);
  }
  function rev(stage) {
    var max = Math.max(3, parseInt(cfg.rev, 10) || 8);
    if (stage.classList.contains('is-redline')) return;
    rpm = Math.min(max, rpm + 1);
    if (!session('axrEiRevHint')) { session('axrEiRevHint', 1); toast(S.revHint, 'tacho'); }
    stage.classList.remove('is-kick');
    void stage.offsetWidth;
    stage.classList.add('is-kick');
    puff(stage);
    gauge(stage);
    clearTimeout(decayT);
    clearInterval(decayI);
    if (rpm >= max) {
      redline(stage);
      return;
    }
    // senza gas il contagiri scende
    decayT = setTimeout(function () {
      decayI = setInterval(function () {
        rpm = Math.max(0, rpm - 1);
        gauge(stage);
        if (!rpm) clearInterval(decayI);
      }, 200);
    }, 850);
  }
  function redline(stage) {
    stage.classList.add('is-redline');
    track('axr_eicma_redline', {});
    var p = prizes.filter(function (x) { return x.kind === 'rev'; })[0];
    // il livello 3 si sblocca solo dopo i livelli 1 e 2
    var locked = !!(p && !won(p.id) && findPrizes().some(function (f) { return !won(f.id); }));
    setTimeout(function () {
      if (locked) toast(S.revLocked, 'tacho');
      else if (!(p && win(p.id, 'rev'))) toast(S.redline, 'tacho');
      setTimeout(function () {
        stage.classList.remove('is-redline');
        rpm = 0;
        gauge(stage);
      }, 900);
    }, reduce ? 0 : 650);
  }
  function puff(stage) {
    if (reduce) return;
    var ex = stage.querySelector('[data-ei-exhaust]');
    if (!ex) return;
    var r = ex.getBoundingClientRect();
    for (var i = 0; i < 2; i++) {
      var s = el('span', 'axr-ei-puff axr-ei-only');
      s.style.left = (r.left + r.width * 0.15) + 'px';
      s.style.top = (r.top + r.height / 2) + 'px';
      s.style.setProperty('--px', Math.round(rand(-70, -30)) + 'px');
      s.style.setProperty('--py', Math.round(rand(-26, 6)) + 'px');
      document.body.appendChild(s);
      setTimeout(remove.bind(null, s), 900);
    }
  }

  /* ---------- Moto d'oro di passaggio (rara) ---------- */
  function runners() {
    var p = prizes.filter(function (x) { return x.kind === 'bike'; })[0];
    if (!cfg.bike || !p || won(p.id)) return;
    var seen = parseInt(session('axrEiRun'), 10) || 0;
    if (seen >= 2) return;
    // non a ogni pagina: è rara
    if (!cfg.preview && Math.random() > 0.4) return;
    setTimeout(function tryRun() {
      if (!isOn() || won(p.id)) return;
      if (document.hidden || (modal && !modal.hidden)) { setTimeout(tryRun, 12000); return; }
      session('axrEiRun', seen + 1);
      spawnRunner();
    }, cfg.preview ? rand(6000, 9000) : rand(20000, 38000));
  }
  function spawnRunner() {
    var g = el('button', 'axr-ei-runner axr-ei-only' + (Math.random() < 0.5 ? ' axr-ei-runner--rev' : ''));
    g.type = 'button';
    g.setAttribute('aria-label', S.passLabel || '');
    g.style.bottom = Math.round(rand(10, 26)) + 'vh';
    g.appendChild(el('span', 'axr-ei-runner__trail'));
    g.appendChild(art('bike-gold', 'axr-ei-runner__bike'));
    g.addEventListener('animationend', function (e) {
      if (e.target !== g) return;
      if (!g.classList.contains('is-caught') && !session('axrEiMissed')) {
        session('axrEiMissed', 1);
        toast(S.bikeMissed, 'bike');
      }
      remove(g);
    });
    document.body.appendChild(g);
    track('axr_eicma_runner', {});
  }
  function catchRunner(g) {
    if (g.classList.contains('is-caught')) return;
    g.classList.add('is-caught');
    burst(g, true);
    var p = prizes.filter(function (x) { return x.kind === 'bike'; })[0];
    setTimeout(remove.bind(null, g), 500);
    if (p) win(p.id, 'bike');
  }

  /* ---------- Finestra con il premio ---------- */
  var modal = null;
  var lastFocus = null;
  // quando si apre la finestra del premio: un tocco in più (es. sulla moto, per arrivare al limitatore) non deve chiuderla prima di leggerla
  var modalAt = 0;
  function openModal(p) {
    if (modal) remove(modal);
    var c = code(p);
    modal = el('div', 'axr-ei-modal axr-ei-only' + (p.rare ? ' axr-ei-modal--rare' : ''));
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'AxrEiModalTitle');
    var bg = el('div', 'axr-ei-modal__bg');
    bg.setAttribute('data-ei-close', '');
    var box = el('div', 'axr-ei-modal__box');
    var x = el('button', 'axr-ei-modal__x');
    x.type = 'button';
    x.setAttribute('data-ei-close', '');
    x.setAttribute('aria-label', S.close || '');
    x.innerHTML = '<span aria-hidden="true">&times;</span>';
    var pic = el('div', 'axr-ei-modal__art');
    var icon = { find: p.id === 2 ? 'helmet-y' : 'helmet', rev: 'tacho', bike: 'bike-gold', gold: 'helmet-gold' }[p.kind] || 'helmet';
    pic.appendChild(art(icon, 'axr-ei-modal__ico'));
    if (p.product && p.product.image) {
      var img = el('img', 'axr-ei-modal__prod');
      img.src = p.product.image;
      img.alt = p.product.title || '';
      img.loading = 'lazy';
      pic.appendChild(img);
    }
    var kicker = el('p', 'axr-ei-modal__kicker');
    kicker.textContent = (p.rare ? S.unlockedRare : S.unlocked) || '';
    var title = el('h2', 'axr-ei-modal__title');
    title.id = 'AxrEiModalTitle';
    title.textContent = p.title || '';
    var text = el('p', 'axr-ei-modal__text');
    text.textContent = p.text || '';
    // il prodotto del premio, linkato
    var plink = null;
    if (p.product && p.product.url) {
      plink = el('a', 'axr-ei-modal__plink');
      plink.href = p.product.url;
      plink.textContent = p.product.title || '';
    }
    var cnd = null;
    if (cond(p)) {
      cnd = el('p', 'axr-ei-modal__cond');
      cnd.textContent = cond(p);
    }
    var coupon = el('button', 'axr-eicoupon');
    coupon.type = 'button';
    coupon.setAttribute('data-ei-copy', c);
    var ct = el('span', 'axr-eicoupon__txt');
    var cl = el('span', 'axr-eicoupon__label');
    cl.textContent = S.yourCode || '';
    var cc = el('span', 'axr-eicoupon__code');
    cc.textContent = c;
    ct.appendChild(cl);
    ct.appendChild(cc);
    var cb = el('span', 'axr-eicoupon__copy');
    cb.setAttribute('data-ei-copy-label', '');
    cb.textContent = S.copy || '';
    coupon.appendChild(ct);
    coupon.appendChild(cb);
    var go = el('a', 'axr-ei-btn');
    // omaggio: si aggiunge al carrello; sconto su una categoria: porta ai prodotti con il codice già applicato
    if (isGift(p)) {
      setApply(go, c, '/cart');
      go.textContent = S.addGift || '';
      go.setAttribute('data-ei-gift', String(p.id));
    } else if (p.product && p.product.url) {
      // prodotto con le taglie (es. il paraschiena): si sceglie nella sua pagina, con il codice già applicato
      setApply(go, c, p.product.url);
      go.textContent = p.product.available === false ? (S.soldOut || '') : ((p.product.single ? S.goProduct : S.chooseSize) || S.goProduct || '');
    } else if (p.link) {
      setApply(go, c, p.link);
      go.textContent = S.goLink || S.apply || '';
    } else {
      setApply(go, c, location.pathname + location.search);
      go.textContent = S.apply || '';
    }
    go.addEventListener('click', function () { track('axr_eicma_apply', { prize_id: p.id }); });
    var later = el('button', 'axr-ei-modal__later');
    later.type = 'button';
    later.setAttribute('data-ei-close', '');
    later.textContent = S.later || '';
    [x, pic, kicker, title, plink, text, cnd, coupon, go, later].forEach(function (n) { if (n) box.appendChild(n); });
    if (S.until) {
      var small = el('p', 'axr-ei-modal__small');
      small.textContent = S.until;
      box.appendChild(small);
    }
    modal.appendChild(bg);
    modal.appendChild(box);
    document.body.appendChild(modal);
    lastFocus = document.activeElement;
    root.classList.add('axr-ei-lock');
    if (!reduce) confetti();
    modalAt = Date.now();
    window.requestAnimationFrame(function () { modal.classList.add('is-open'); });
    coupon.focus({ preventScroll: true });
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    root.classList.remove('axr-ei-lock');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  function trapFocus(e) {
    var f = modal.querySelectorAll('button, a[href]');
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  // bandiere a scacchi e coriandoli rossi quando si vince
  function confetti() {
    for (var i = 0; i < 26; i++) {
      var c = el('span', 'axr-ei-confetti axr-ei-only' + (i % 3 === 0 ? ' axr-ei-confetti--check' : (i % 3 === 1 ? ' axr-ei-confetti--white' : '')));
      c.style.left = rand(5, 95).toFixed(1) + 'vw';
      c.style.setProperty('--cx', Math.round(rand(-60, 60)) + 'px');
      c.style.setProperty('--cr', Math.round(rand(-540, 540)) + 'deg');
      c.style.setProperty('--cd', rand(1.6, 2.8).toFixed(2) + 's');
      c.style.animationDelay = rand(0, 0.35).toFixed(2) + 's';
      document.body.appendChild(c);
      setTimeout(remove.bind(null, c), 3400);
    }
  }
  function applyUrl(c, back) {
    return '/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(back || '/');
  }
  function cartRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  // link che applica un codice: href di riserva (il link di Shopify) e, per lo script, codice e pagina di arrivo
  function setApply(a, c, back) {
    a.href = applyUrl(c, back);
    a.setAttribute('data-ei-apply', c);
    a.setAttribute('data-ei-back', back || '/');
  }
  // applica il codice AGGIUNGENDOLO a quelli già nel carrello (/cart/update.js con l'elenco completo),
  // così chi usa più premi non perde il primo; se qualcosa non va si usa il link di Shopify
  function applyCode(c, back, a) {
    if (a) a.classList.add('is-busy');
    var fail = function () { window.location.href = applyUrl(c, back); };
    fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var list = [];
        (cart.discount_codes || []).forEach(function (d) { if (d && d.code) list.push(String(d.code)); });
        var has = list.some(function (x) { return x.toLowerCase() === String(c).toLowerCase(); });
        if (!has) list.push(c);
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: list.join(',') })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('update');
        window.location.href = back || '/';
      })
      .catch(fail);
  }
  // omaggio: lo aggiunge al carrello e poi applica il codice
  function addGift(a) {
    var p = prize(parseInt(a.getAttribute('data-ei-gift'), 10));
    if (!p || !p.product || !p.product.variant) return false;
    var label = a.textContent;
    a.textContent = S.adding || label;
    a.classList.add('is-busy');
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: p.product.variant, quantity: 1, properties: { _eicma_premio: String(p.id) } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      applyCode(code(p), a.getAttribute('data-ei-back') || '/cart', null);
    }).catch(function () {
      a.textContent = label;
      a.classList.remove('is-busy');
      toast(S.addError, 'helmet');
    });
    return true;
  }

  /* ---------- Messaggio in basso ---------- */
  var toastEl = null;
  var toastTimer = 0;
  function toast(msg, icon) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = el('div', 'axr-ei-toast axr-ei-only');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    toastEl.appendChild(art(icon || 'helmet', 'axr-ei-toast__ico'));
    var m = el('span', 'axr-ei-toast__msg');
    m.textContent = msg;
    toastEl.appendChild(m);
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    // i messaggi lunghi restano di più, così si fa in tempo a leggerli
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, Math.max(4600, Math.min(11000, String(msg).length * 60)));
  }

  /* ---------- Copia del codice ---------- */
  function fallbackCopy(text) {
    var t = el('textarea');
    t.value = text;
    t.setAttribute('readonly', '');
    t.style.position = 'fixed';
    t.style.top = '-1000px';
    document.body.appendChild(t);
    t.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    remove(t);
    return ok;
  }
  function copyCode(c, btn) {
    function done(ok) {
      if (btn) {
        btn.classList.add('is-copied');
        var lab = btn.querySelector('[data-ei-copy-label]');
        if (lab) {
          if (!lab.getAttribute('data-text')) lab.setAttribute('data-text', lab.textContent);
          lab.textContent = S.copied || '';
        }
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (lab) lab.textContent = lab.getAttribute('data-text');
        }, 2200);
      }
      toast(fmt(ok ? S.copiedToast : S.copyFail, { code: c }), 'flag');
      track('axr_eicma_copy', {});
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(c).then(function () { done(true); }, function () { done(fallbackCopy(c)); });
    } else {
      done(fallbackCopy(c));
    }
  }

  /* ---------- Fari: buio intorno, i caschi nascosti brillano ---------- */
  function lights() {
    if (!cfg.lights || document.querySelector('.axr-ei-lights')) return;
    var t = el('div', 'axr-ei-lights axr-ei-only');
    t.setAttribute('aria-hidden', 'true');
    var msg = el('p', 'axr-ei-lights__msg');
    msg.textContent = S.lights || '';
    t.appendChild(msg);
    t.style.setProperty('--lx', Math.round(window.innerWidth / 2) + 'px');
    t.style.setProperty('--ly', Math.round(window.innerHeight / 2) + 'px');
    var glows = [];
    document.querySelectorAll('.axr-ei-hidden:not(.is-found)').forEach(function (p) {
      var g = el('span', 'axr-ei-lights__glow' + (p.getAttribute('data-ei-kind') === 'helmet-gold' ? ' is-gold' : ''));
      t.appendChild(g);
      glows.push([p, g]);
    });
    function placeGlows() {
      glows.forEach(function (x) {
        var r = x[0].getBoundingClientRect();
        x[1].style.left = Math.round(r.left + r.width / 2) + 'px';
        x[1].style.top = Math.round(r.top + r.height / 2) + 'px';
        x[1].style.display = r.width ? '' : 'none';
      });
    }
    function move(e) {
      var p = e.touches ? e.touches[0] : e;
      if (!p) return;
      t.style.setProperty('--lx', Math.round(p.clientX) + 'px');
      t.style.setProperty('--ly', Math.round(p.clientY) + 'px');
    }
    function end() {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('touchmove', move);
      window.removeEventListener('scroll', placeGlows);
      document.removeEventListener('keydown', onEsc);
      t.classList.remove('is-on');
      setTimeout(remove.bind(null, t), 600);
    }
    function onEsc(e) { if (e.key === 'Escape') end(); }
    document.body.appendChild(t);
    placeGlows();
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('scroll', placeGlows, { passive: true });
    document.addEventListener('keydown', onEsc);
    window.requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(end, 10000);
    track('axr_eicma_lights', {});
  }
  var typed = '';
  document.addEventListener('keydown', function (e) {
    if (!isOn()) return;
    if (modal && !modal.hidden) {
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'Tab') trapFocus(e);
      return;
    }
    var tg = e.target;
    if (tg && (tg.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(tg.tagName))) return;
    if (!e.key || e.key.length !== 1) return;
    typed = (typed + e.key.toLowerCase()).slice(-5);
    if (typed === 'vroom' || typed.slice(-4) === 'brum') {
      typed = '';
      lights();
    }
  });

  /* ---------- Fascia della caccia: premi bloccati e sbloccati ---------- */
  function paintHunt() {
    document.querySelectorAll('[data-ei-hunt]').forEach(function (h) {
      var nx = nextFind();
      var count = h.querySelector('[data-ei-count]');
      if (count) count.textContent = String(st.f);
      var bar = h.querySelector('[data-ei-bar]');
      var goal = nx ? nx.need : (findPrizes().slice(-1)[0] || { need: st.f || 1 }).need;
      if (bar) bar.style.setProperty('--ei-p', Math.min(1, st.f / Math.max(1, goal)).toFixed(3));
      var next = h.querySelector('[data-ei-next]');
      if (next) {
        // la frase e, sotto, cosa manca da fare
        var hs = huntState();
        next.textContent = '';
        var nt = el('span', 'axr-eihunt__next-t');
        nt.textContent = hs.t;
        next.appendChild(nt);
        if (hs.d) {
          var nd = el('span', 'axr-eihunt__next-d');
          nd.textContent = hs.d;
          next.appendChild(nd);
        }
      }
      h.querySelectorAll('[data-ei-prize]').forEach(function (card) {
        var id = parseInt(card.getAttribute('data-ei-prize'), 10);
        var p = prize(id);
        var isWon = !!(p && won(id));
        card.classList.toggle('is-won', isWon);
        card.classList.toggle('is-off', !p);
        var slot = card.querySelector('[data-ei-reveal]');
        if (!slot) return;
        if (!isWon) { slot.textContent = ''; return; }
        if (slot.getAttribute('data-done') === '1') return;
        slot.setAttribute('data-done', '1');
        var t = el(p.product && p.product.url ? 'a' : 'span', 'axr-eihunt__ptitle');
        if (p.product && p.product.url) t.href = p.product.url;
        t.textContent = p.title || '';
        var c = code(p);
        var b = el('button', 'axr-eicoupon axr-eicoupon--s');
        b.type = 'button';
        b.setAttribute('data-ei-copy', c);
        b.innerHTML = '<span class="axr-eicoupon__txt"><span class="axr-eicoupon__code"></span></span><span class="axr-eicoupon__copy" data-ei-copy-label></span>';
        b.querySelector('.axr-eicoupon__code').textContent = c;
        b.querySelector('[data-ei-copy-label]').textContent = S.copy || '';
        var again = el('button', 'axr-eihunt__again');
        again.type = 'button';
        again.setAttribute('data-ei-show', String(id));
        again.textContent = S.cartApply || '';
        slot.appendChild(t);
        if (cond(p)) {
          var pc = el('span', 'axr-eihunt__pcond');
          pc.textContent = cond(p);
          slot.appendChild(pc);
        }
        slot.appendChild(b);
        slot.appendChild(again);
      });
    });
  }

  /* ---------- Carrello: i premi trovati, con «Applica» ---------- */
  // quali codici Shopify ha inserito ma NON applica (applicable: false in /cart.js), letti una volta per elenco di codici
  var codeInfo = { key: '', off: null, busy: false };
  function codesOff(applied) {
    var key = applied.filter(Boolean).join(',');
    if (!key) return {};
    if (codeInfo.key === key && codeInfo.off) return codeInfo.off;
    if (codeInfo.key === key && codeInfo.busy) return {};
    codeInfo.key = key;
    codeInfo.off = null;
    codeInfo.busy = true;
    fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var off = {};
        (cart.discount_codes || []).forEach(function (d) {
          if (d && d.code && d.applicable === false) off[String(d.code).toLowerCase()] = true;
        });
        if (codeInfo.key !== key) return;
        codeInfo.off = off;
        codeInfo.busy = false;
        if (Object.keys(off).length) paintCarts();
      })
      .catch(function () { if (codeInfo.key === key) { codeInfo.off = {}; codeInfo.busy = false; } });
    return {};
  }
  function paintCarts() {
    var list = prizes.filter(function (p) { return won(p.id); });
    document.querySelectorAll('[data-ei-cart]').forEach(function (slot) {
      // codici già attivi nel carrello e conteggio senza omaggi: li scrive il Liquid nel posto dei premi
      var applied = String(slot.getAttribute('data-ei-applied') || '').toLowerCase().split(',');
      var n = parseInt(slot.getAttribute('data-ei-n'), 10) || 0;
      var sum = parseInt(slot.getAttribute('data-ei-sum'), 10) || 0;
      var items = String(slot.getAttribute('data-ei-items') || ',');
      var off = codesOff(applied);
      var sig = list.map(function (p) { return p.id; }).join(',') + '|' + applied.join(',') + '|' + n + '|' + sum + '|' + items + '|' + Object.keys(off).join(',');
      if (slot.getAttribute('data-sig') === sig) return;
      slot.setAttribute('data-sig', sig);
      slot.textContent = '';
      if (!list.length) return;
      var box = el('div', 'axr-eicart');
      var h = el('p', 'axr-eicart__title');
      h.appendChild(art('flag', 'axr-eicart__ico'));
      var ht = el('span');
      ht.textContent = S.cartTitle || '';
      h.appendChild(ht);
      box.appendChild(h);
      list.forEach(function (p) {
        var c = code(p);
        var row = el('div', 'axr-eicart__row');
        var t = el(p.product && p.product.url ? 'a' : 'span', 'axr-eicart__name');
        if (p.product && p.product.url) t.href = p.product.url;
        t.textContent = p.title || '';
        var info = el('span', 'axr-eicart__info');
        info.appendChild(t);
        if (cond(p)) {
          var d = el('span', 'axr-eicart__text');
          d.textContent = cond(p);
          info.appendChild(d);
        }
        // cosa manca, senza contare omaggi e prodotti dei premi; codice inserito ma non applicato da Shopify
        var isOff = !!off[c.toLowerCase()] && applied.indexOf(c.toLowerCase()) !== -1;
        var miss = isOff ? (S.cartNotActive || '') : missing(p, n, sum);
        var st2 = el('span', 'axr-eicart__state' + (miss ? ' is-miss' : ' is-ok'));
        st2.textContent = miss || S.condOk || '';
        info.appendChild(st2);
        row.appendChild(info);
        var inCart = !!(p.product && p.product.handle && items.indexOf(',' + p.product.handle + ',') !== -1);
        if (isOff) {
          var moreOff = el('a', 'axr-eicart__apply axr-eicart__apply--ghost');
          moreOff.href = cfg.collection || '/collections/all';
          moreOff.textContent = S.goShop || '';
          row.appendChild(moreOff);
        } else if (applied.indexOf(c.toLowerCase()) !== -1) {
          var ok = el('span', 'axr-eicart__ok');
          ok.textContent = S.cartActive || '';
          row.appendChild(ok);
        } else if (miss) {
          var more = el('a', 'axr-eicart__apply axr-eicart__apply--ghost');
          more.href = cfg.collection || '/collections/all';
          more.textContent = S.goShop || '';
          row.appendChild(more);
        } else {
          var a = el('a', 'axr-eicart__apply');
          a.title = c;
          if (isGift(p) && !inCart) {
            // omaggio non ancora nel carrello: si aggiunge e si applica il codice
            setApply(a, c, location.pathname);
            a.setAttribute('data-ei-gift', String(p.id));
            a.textContent = S.cartAddApply || S.cartApply || '';
          } else if (p.product && p.product.url && !p.product.single && !inCart) {
            setApply(a, c, p.product.url);
            a.textContent = S.chooseSize || S.cartApply || '';
          } else {
            setApply(a, c, location.pathname);
            a.textContent = S.cartApply || '';
          }
          row.appendChild(a);
        }
        box.appendChild(row);
      });
      // con più premi: i prodotti del carrello valgono per un premio solo (regola di Shopify)
      if (list.length > 1 && S.cartRule) {
        var rule = el('p', 'axr-eicart__rule');
        rule.textContent = S.cartRule;
        box.appendChild(rule);
      }
      slot.appendChild(box);
    });
  }

  /* ---------- Clic ---------- */
  // in fase di cattura, così le schede prodotto non aprono il prodotto quando si tocca un casco nascosto
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !isOn()) return;
    var c = t.closest('[data-ei-copy]');
    if (c) { e.preventDefault(); copyCode(c.getAttribute('data-ei-copy') || '', c); return; }
    var h = t.closest('.axr-ei-hidden');
    if (h) { e.preventDefault(); e.stopPropagation(); foundItem(h); return; }
    var r = t.closest('.axr-ei-runner');
    if (r) { e.preventDefault(); catchRunner(r); return; }
    var l = t.closest('[data-ei-light]');
    if (l) { e.preventDefault(); e.stopPropagation(); lights(); return; }
    var rv = t.closest('[data-ei-rev]');
    if (rv) { e.preventDefault(); rev(rv.closest('[data-ei-stage]') || rv); return; }
    var g = t.closest('[data-ei-gift]');
    if (g && addGift(g)) { e.preventDefault(); return; }
    var ap = t.closest('[data-ei-apply]');
    if (ap && !ap.classList.contains('is-busy')) {
      e.preventDefault();
      applyCode(ap.getAttribute('data-ei-apply') || '', ap.getAttribute('data-ei-back') || '/', ap);
      return;
    }
    var sh = t.closest('[data-ei-show]');
    if (sh) {
      e.preventDefault();
      var p = prize(parseInt(sh.getAttribute('data-ei-show'), 10));
      if (p && won(p.id)) openModal(p);
      return;
    }
    var cl = t.closest('[data-ei-close]');
    if (cl) {
      e.preventDefault();
      var wait = cl.classList.contains('axr-ei-modal__bg') ? 1600 : 700;
      if (Date.now() - modalAt < wait) return;
      closeModal();
      return;
    }
    if (t.closest('[data-ei-lights-btn]')) { e.preventDefault(); lights(); }
  }, true);

  /* ---------- In vetrina: un prodotto a caso sulla pedana ---------- */
  function stands() {
    document.querySelectorAll('[data-ei-stand]').forEach(function (sec) {
      if (sec.getAttribute('data-ei-ready')) return;
      sec.setAttribute('data-ei-ready', '1');
      var slides = Array.prototype.slice.call(sec.querySelectorAll('[data-ei-slide]'));
      if (!slides.length) return;
      var dotsBox = sec.querySelector('[data-ei-dots]');
      var spin = sec.querySelector('[data-ei-spin]');
      var cur = -1;
      var dots = [];
      if (slides.length < 2 && spin) spin.hidden = true;
      if (dotsBox && slides.length > 1) {
        slides.forEach(function (s, i) {
          var d = el('button', 'axr-eistand__dot');
          d.type = 'button';
          d.setAttribute('aria-label', String(i + 1) + ' / ' + slides.length);
          d.addEventListener('click', function () { show(i); stop(); });
          dotsBox.appendChild(d);
          dots.push(d);
        });
      }
      function show(i) {
        if (i === cur) return;
        cur = i;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-on', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          var a = s.querySelector('a');
          if (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function pick() {
        if (slides.length < 2) return 0;
        var n;
        do { n = Math.floor(Math.random() * slides.length); } while (n === cur);
        return n;
      }
      var timer = 0;
      function stop() { clearInterval(timer); timer = 0; }
      show(pick());
      if (spin) spin.addEventListener('click', function () { show(pick()); stop(); track('axr_eicma_spin', {}); });
      if (!reduce && slides.length > 1) {
        timer = setInterval(function () { if (!document.hidden) show(pick()); }, 8000);
        sec.addEventListener('pointerenter', stop);
        sec.addEventListener('focusin', stop);
      }
    });
  }

  /* ---------- «Scopri le offerte»: porta alla griglia dei prodotti della collezione ---------- */
  function gridTarget() {
    return document.getElementById('AxrEiGrid') || document.querySelector('[data-section-type="collection-template"]');
  }
  function toGrid(smooth) {
    var t = gridTarget();
    if (!t) return false;
    t.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href$="#AxrEiGrid"]') : null;
    if (!a || a.pathname !== location.pathname) return;
    if (toGrid(true)) e.preventDefault();
  });
  if (location.hash === '#AxrEiGrid' && !/[?&]reparto=/.test(location.search)) {
    window.addEventListener('load', function () { setTimeout(function () { toGrid(false); }, 300); });
  }

  /* ---------- Reparti: apre la linguetta del reparto nella sezione «Le offerte della fiera» ---------- */
  function gridArea(key, smooth) {
    var grid = document.querySelector('[data-ei-grid]');
    if (!grid) return false;
    var chip = grid.querySelector('[data-ei-area="' + String(key).replace(/[^a-z0-9-]/gi, '') + '"]');
    if (chip && chip.getAttribute('aria-selected') !== 'true') chip.click();
    grid.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-ei-reparto]') : null;
    if (!a || a.pathname !== location.pathname) return;
    if (gridArea(a.getAttribute('data-ei-reparto'), true)) e.preventDefault();
  });
  (function () {
    var m = /[?&]reparto=([a-z0-9-]+)/i.exec(location.search);
    if (!m) return;
    var go = function () { setTimeout(function () { gridArea(m[1], false); }, 300); };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
  })();

  /* ---------- Avvio ---------- */
  var slotTimer = 0;
  function watchSlots() {
    // il carrello si ridisegna da solo: riempie i posti dei premi quando ricompaiono
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(slotTimer);
      slotTimer = setTimeout(paintCarts, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  // le promo in cima alle collezioni restano chiuse anche su computer (barra sottile, «Dettagli» le apre)
  function start() {
    if (started || !isOn()) return;
    started = true;
    paintHunt();
    paintCarts();
    stands();
    watchSlots();
    // i caschi si nascondono a pagina caricata, quando le schede hanno preso il loro posto
    var go = function () { setTimeout(hideItems, 700); };
    if (document.readyState === 'complete') go();
    else {
      window.addEventListener('load', go);
      setTimeout(hideItems, 5000);
    }
    runners();
  }
  document.addEventListener('axr:eicma', function (e) { if (e.detail && e.detail.on) start(); });
  // editor del tema: sezioni ricaricate
  document.addEventListener('shopify:section:load', function () { if (started) { paintHunt(); paintCarts(); stands(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
